<template>
  <div class="unit">
    <div class="unit-item">
      <div class="unit-item-h1">
        <h1>{{  $t('DepartmentClassification') }}</h1>
        <div class="unit-item-h1-down"></div>
      </div>
      <div class="unit-img-out">
        <div class="unit-img-item" v-for="(item, index) in box" :key="index" :style="{ backgroundImage: `url(${require(`@/assets/companyprofilepic/${item.img}`)})` }" data-aos="zoom-in">
          <div class="unit-img-item-span">
            <span>{{ $t(`box.${item.path}`) }}</span>
          </div>
          <div class="unit-btn">
          <router-link :to="`/products/${item.path}`">
            <button>{{  $t('more') }}</button>
          </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Unit",
  data() {
    return {
      box: [
        { path: 'accessory', img: 'unit-1.png' },
        { path: 'celoscope', img: 'unit-2.png' },
        { path: 'ureter', img: 'unit-3.png' },
        { path: 'hysteroscope', img: 'unit-4.png' },
        { path: 'ent', img: 'unit-5.png' },
        { path: 'arthroscopy', img: 'unit-6.png' }
      ]
    };
  },
  
};
</script>

<style scoped>
.unit {
  background-color: #ededed;
  margin-top: 27px;
  padding-bottom: 30px;
}

.unit-item {
  margin: 0 20vw;
}

.unit-item-h1 h1 {
  text-align: left;
  margin: 0;
  padding-top: 20px;
}

.unit-item-h1-down {
  height: 5px;
  background-color: #018fd7;
  margin-right: 96%;
  border-radius: 5px;
}

.unit-img-out {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  padding-top: 1rem;
}

.unit-img-item {
  background-color: #fff;
  border-radius: 10px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  aspect-ratio: 1;
  position: relative;
  width: 20vw;
  height: auto;
}

.unit-img-item-span {
  text-align: left;
  padding-left: 10px;
  padding-top: 10px;
  color: #a0a0a0;
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 5px 10px;
}

.unit-btn {
  text-align: center;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  padding-bottom: 20px;
  white-space: nowrap;
}

.unit-btn button {
  background-color: transparent;
  border: 1px solid #018fd7;
  border-radius: 20px;
  padding: 7px 20px;
  cursor: pointer;
  color: #018fd7;
  font-size: 14px;
}

.unit-btn button:hover {
  background-color: #018fd7;
  color: white;
}

@media (max-width: 768px) {
  .unit-img-out {
    grid-template-columns: 1fr;
    padding: 1rem;
  }

  .unit-img-item {
  background-color: #fff;
  border-radius: 10px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  aspect-ratio: 1;
  position: relative;
  width: 50vw;
  height: auto;
}
}
</style>



// WEBPACK FOOTER //
// src/views/home/products/Unit.vue